// Styles
import "vuetify/styles";

import ru from "../i18n/vuetify/ru";
// Vuetify
import { createVuetify } from "vuetify";
// Components
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";
import icons from "./icons";

import { md3 } from "vuetify/blueprints";
const Vuetify = createVuetify({
    blueprint: md3,
    icons,
    directives,
    components: {
        ...components,
        ...labsComponents,
    },
    locale: {
        locale: "ru",
        fallback: "ru",
        messages: { ru },
    },
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                dark: false,
                colors: {
                    white: "#FFFFFF",
                    primary: "#00494f",
                    error: "#e00051",
                },
            },
            dark: {
                dark: true,
                colors: {
                    white: "#FFFFFF",
                    primary: "#285b61",
                    error: "#e00051",
                },
            },
        },
    },
});
export default Vuetify;
